const createFormData = (data: Record<string, any>, parentKey = ""): FormData => {
    const formData = new FormData();

    const appendFormData = (key: string, value: any) => {
        if (value === undefined) {
            // Skip undefined values
        } else if (value instanceof Date) {
            formData.append(key, value.toISOString());
        } else if (Array.isArray(value)) {
            if (value.length === 0) {
                formData.append(key, "[]");
            } else {
                value.forEach((item, index) => {
                    const arrayKey = `${key}[${index}]`;
                    appendFormData(arrayKey, item);
                });
            }
        } else if (value && typeof value === "object" && key !== "serviceMaterial") {
            for (const [nestedKey, nestedValue] of Object.entries(value)) {
                const nestedFormKey = `${key}[${nestedKey}]`;
                appendFormData(nestedFormKey, nestedValue);
            }
        } else if (key === "serviceMaterial" && typeof value === "object") {
            // Flatten for "serviceMaterialFile"
            for (const [nestedKey, nestedValue] of Object.entries(value)) {
                const flatKey = `${key}`;
                appendFormData(flatKey, nestedValue);
            }
        } else if (typeof value === "string" && value.startsWith("data:image/")) {
            const byteCharacters = atob(value.split(",")[1]);
            const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "image/png" });
            formData.append(key, blob, "image.png");
        } else if (typeof value === "string" && value.startsWith("data:video/")) {
            const byteCharacters = atob(value.split(",")[1]);
            const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "video/mp4" });
            formData.append(key, blob, "video.mp4");
        } else if (typeof value === "string" && value.startsWith("data:application/pdf")) {
            const byteCharacters = atob(value.split(",")[1]);
            const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            formData.append(key, blob, "document.pdf");
        } else if (value instanceof ArrayBuffer) {
            const blob = new Blob([value], { type: "image/png" });
            const file = new File([blob], "image.png", { type: "image/png" });
            formData.append(key, file);
        } else {
            formData.append(key, value as string);
        }
    };

    for (const [key, value] of Object.entries(data)) {
        const formKey = parentKey ? `${parentKey}[${key}]` : key;
        appendFormData(formKey, value);
    }

    return formData;
};

export default createFormData;
